import { Member, RecommendedUser, User } from '@nextforce/api'
import { Avatar, AvatarProps, makeStyles, ThemeMode } from '@rneui/themed'
import React from 'react'
import { stripInvalidCodepoints } from 'shared/utils'
import { USER_PHOTO_HEX_COLORS } from 'users/constants'

interface Props {
  user: User | Member | RecommendedUser | undefined
  showAvatarIfNoPhone?: boolean
  size?: AvatarProps['size']
  hasInterests?: boolean
}

const TEXT_ONLY_AVATAR_BACKGROUND = '#4e5665'

export function UserAvatar({
  user,
  showAvatarIfNoPhone,
  size,
  hasInterests,
}: Props) {
  let color: string | undefined

  const hasAvatar = !!user?.photoUrl
  const showAvatar = showAvatarIfNoPhone || !!user?.phoneNumber
  const showTextOnlyAvatar = !!user?.phoneNumber && !user?.hasApp

  if (user) {
    color = showTextOnlyAvatar
      ? TEXT_ONLY_AVATAR_BACKGROUND
      : showAvatar
      ? getBackgroundColorById(user.id)
      : 'white'
  }

  const styles = useStyles({ color, showAvatar })

  return (
    <Avatar
      rounded
      size={size}
      source={
        user
          ? showAvatar
            ? hasAvatar
              ? { uri: user.photoUrl }
              : undefined
            : undefined
          : hasInterests
          ? require('assets/routes/open_shifts/open_shift_with_interest.png')
          : require('assets/routes/open_shifts/open_shift_no_interest.png')
      }
      title={
        hasAvatar ? undefined : stripInvalidCodepoints(user?.initials ?? '')
      }
      containerStyle={styles.container}
      titleStyle={styles.title}
      avatarStyle={{ flex: 1 }}
    />
  )
}

export function getBackgroundColorById(
  userId: string,
  themeMode: ThemeMode = 'dark'
) {
  function convertIdToColorIndex(id?: string) {
    const defaultIndex = 0

    if (!id) {
      // Should not happen in normal circumstances
      return defaultIndex
    }

    const idVal = parseInt(id)

    if (isNaN(idVal)) {
      return defaultIndex
    }

    return idVal % USER_PHOTO_HEX_COLORS.length
  }

  return USER_PHOTO_HEX_COLORS[convertIdToColorIndex(userId)][themeMode]
}

const useStyles = makeStyles(
  (
    theme,
    props: { color?: string; showAvatar: boolean; textColor?: string }
  ) => ({
    container: {
      backgroundColor: props.color ?? theme.colors?.grey5,
      borderWidth: props.showAvatar ? 0 : 2,
      borderColor: theme.colors?.grey5,
      // alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      color: '#353B4A',
    },
  })
)
